import { PORTALVIEW_PERMISSION } from 'shared/constants/fields';
import { isNilOrEmptyIterables, safeJsonParse } from './functions';

export function getViewPermissions() {
  const portalView = safeJsonParse(localStorage.getItem('portalView')) ?? {};
  const userPermissions = Object.values(PORTALVIEW_PERMISSION).reduce(
    (acc, key) => {
      const val = portalView[key]?.hidden;
      return {
        ...acc,
        [key]: isNilOrEmptyIterables(val) ? false : !Boolean(val),
      };
    },
    {}
  );

  return userPermissions;
}
